<template>
    <div class="item-info">
        <div class="input_div" >
            <div>当前案例：</div> 
            <select v-model="event_info.sample_name">
                <option 
                    v-for="(v,idx) in sample_list" 
                    :value="v"
                    :key = "idx"
                >{{v}}
                </option>
            </select>
        </div>

         
       <div class="input_div">
            <div>事件A：</div>
            <input type="text" v-model.lazy="event_info.event_A">
        </div>
        
       <div class="input_div">
            <div>事件B：</div> 
            <input type="text" v-model.lazy="event_info.event_B">
        </div>

    </div>
    
</template>

<script>
 import {msgbox} from '~js/smallarAlert.esm.js';
export default {
   name:'BayItemInfo',
    props:{
        event_info:Object,
        sample_list:Array,
    },
    methods:{
        sample_change(){
            console.log('event_info change: from change');
            console.log(this.event_info);
           //this.$emit('sample_change');
        }
    },
    watch:{
        "event_info.event_B":function(newV,oldV){
                console.log('event info event_b changed:' + newV);
               if(!newV){
                   this.event_info.event_B = oldV;
                   return;
               };
               if(newV.endsWith('率')){
                   this.event_info.event_B = oldV;
                   msgbox({type:'pop',title:'提示',msg:'通常事件不能定义成概率',show_time:800})
               }
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/var.styl';
.item-info
    font-family:auto;
    font-size:18px;

    left:50%;

    display:flex;
    justify-content:center
    //display:inline-block;

    input
        clear_default_style();
        border-bottom:1px solid gray;
        width:95px;
        text-align:center;

    select    
        width:110px;
    
    input,select
        font-family:inherit;
        font-size:inherit;
        font-weight:lighter;
    
    .input_div
        margin:0px 20px;
        display:flex;

 

</style>
